(function ($) {
    $(function () {

        var basketBtn = $('button[name="add-to-cart"], a[name="add-to-cart"], button.single_add_to_cart_button');

        if (basketBtn.length < 1) {
            return;
        }

        basketBtn.append('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M5.5 21c-.78 0-1.46-.45-1.79-1.1L1.1 10.44 1 10a1 1 0 011-1h4.58l4.6-6.57a.997.997 0 011.65.01L17.42 9H22a1 1 0 011 1l-.04.29-2.67 9.61c-.33.65-1.01 1.1-1.79 1.1h-13M12 4.74L9 9h6l-3-4.26M12 13a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2z"/></svg>');

    });
})(jQuery);